
import Vue from 'vue';
import { components } from '../page-items';
import carrayGroup from './CArrayGroup.vue';

export default Vue.extend({
  components: {
    ...components, carrayGroup
  },
  props: {
    group: { type: Object, default: () => {} },
    data: { type: Object, default: () => {} },
    getVariable: { type: Function, default: () => () => {} },
    callFunction: { type: Function, default: () => () => {} },
    onChange: { type: Function, default: () => {} },
    parent: { type: Object, default: () => {} },
    dialog: { type: Boolean, default: true },
    groupDisabled: { type: Boolean, default: false }
  },
  data(): { valid: boolean } {
    return { valid: false }
  },
  computed: {
    config: function () {
      // @ts-ignore
      return this.group.config;
    }
  }
})
